/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { Link } from 'react-router-dom';
import {
    object, bool, func, string, shape, arrayOf, number,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import track from 'react-tracking';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import { SvgIcon } from '@material-ui/core';

import ReactMarkdown from 'react-markdown';
import ReactHtmlParser from 'react-html-parser';
import CheckBoxOutlineBlankOutlined from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined';
import { ChevronDown, ChevronUp } from 'lucide-react';
import {
    getPassportSubscriptionStatus,
    getIsPassportCapPriceReached,
    dynamicPassportCharge,
    getPassportData,
    getPassportError,
    getAppliedPromotions,
    getCartOrder,
    getPassportABData,
    getPassportCampaignData, getPassportSignInData, getUserProfile, isPassportInEligibleProductsInCart, getCartCount,
} from '../../../../../../../../../state/ducks/Common/Common-Selectors';

import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

import getTrackingLabel from '../../../../../../../../helpers/passportHelper';
import PassportBenefitsInfo from '../PassportBenefitsInfo/PassportBenefitsInfo';
import ErrorMessage from '../../../ErrorMessage/ErrorMessage';
import { getPassportPageUrl, getFeatureFlags } from '../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import customBreakpoints from '../../../../../../../../helpers/customBreakpoints';
import { trackPassportData } from '../../../../../../../../helpers/tracking/utils/trackingUtils';
import { trackPage } from '../../../../../../../../helpers/tracking/common/commonTrackingHelpers';
import { setPassportData, triggerPassportSubscription } from '../../../../../../../../../state/ducks/Passport/Passport-Action';
import { clearPassportError } from '../../../../../../../../../state/ducks/Payment/Payment-Actions';
import validatePassport from '../../../../../../../../helpers/validatePassport';
import { getActiveABTest, getActiveABTests } from '../../../../../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import { getSkuWithoutBrand } from '../../../../../../../../helpers/common/helper';
import { withAuth } from '../../../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import { getIsAuthenticatedStatus } from '../../../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import ResponsiveImage from '../../../../../../../../components/GraphqlComponents/GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const styles = (theme) => ({
    passPortCard: {
        padding: '5px',
        [theme.breakpoints.down('600')]: {
            margin: '5px 16px',
        },
        [theme.breakpoints.only('xs')]: {
            margin: '9px auto 9px auto',
            padding: '0',
        },
    },
    flexContainer: {
        alignItems: 'center',
        justifyContent: 'space-around',
        flexWrap: 'nowrap',
        [theme.breakpoints.down('600')]: {
            padding: '0 10px',
        },
    },
    checkboxContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    alignLeft: {
        textAlign: 'left',
    },
    boldText: {
        fontWeight: 600,
    },
    linkStyle: {
        color: theme.palette.colorNeutral80,
        cursor: 'pointer',
        textDecoration: 'underline',
        fontSize: '13px',
    },
    passportImg: {
        padding: '0px !important',
        textAlign: 'right',
        maxWidth: '70px',
        [theme.breakpoints.up(770)]: {
            flexBasis: '5%',
            marginRight: 5,
        },
        [theme.breakpoints.down(770)]: {
            flexBasis: '10%',
        },
    },
    passportDesc: {
        fontSize: '14px',
        color: theme.palette.black,
        lineHeight: '20px',
        marginRight: '10px',
        display: 'block',
        [theme.breakpoints.down('md')]: {
            marginTop: 0,
        },
        [theme.breakpoints.down(1025)]: {
            marginTop: 8,
        },
        [theme.breakpoints.down(770)]: {
            margin: 0,
            fontSize: '12px',
            lineHeight: '16px',
            alignSelf: 'flex-start',
            '& p': {
                margin: 0,
            },
        },
    },
    textBlock: {
        [theme.breakpoints.down(1200)]: {
            flexGrow: 0,
            maxWidth: '75%',
            flexBasis: '75%',
        },
    },
    passportDescFood: {
        fontSize: '13px',
        color: theme.palette.black,
        lineHeight: '17px',
        width: '151px',
        height: '58px',
        marginLeft: '19px',
        // Mobile
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    passportBundleDescFood: {
        fontSize: '13px',
        color: theme.palette.black,
        lineHeight: '17px',
        paddingTop: '10px',
        marginLeft: '19px',
        // Mobile
        [theme.breakpoints.down('sm')]: {
            width: '97%',
        },
    },
    passportDescFoodPayment: {
        fontSize: '13px',
        color: theme.palette.black,
        lineHeight: '17px',
        width: '151px',
        height: '70px',
        marginLeft: '19px',
        [theme.breakpoints.only('xs')]: {
            width: 'calc(100% - 19px)',
            height: 'auto',
        },
    },
    contInfo: {
        textAlign: 'left',
        zIndex: '14',
        borderLeft: `1px solid ${theme.palette.black}`,
    },
    root: {
        boxSizing: 'border-box',
        padding: 0,
        marginBottom: '20px',
        color: theme.palette.black,
        fontSize: '18px',
        overflow: 'hidden',
        transition: 'height 0.2s ease-in-out 0.0s',
    },
    checkbox: {
        padding: '0',
        [theme.breakpoints.down('600')]: {
            '& svg': {
                fontSize: '24px',
            },
        },
    },
    checked: {
        color: '#9D9D9D',
        '&$checked': {
            color: '#2F2F2F',
        },
    },
    infoIconWrapper: {
        position: 'relative',
        height: '50px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '13px',
        '&> *': {
            top: '20px',
            left: '-4px',
            width: '20px',
            padding: '3px 0px 0px 3px',
            height: '20px',
            borderRadius: '100px',
        },
        [theme.breakpoints.up(601)]: {
            justifyContent: 'flex-end',
        },
    },
    iconText: {
        [theme.breakpoints.down(600)]: {
            display: 'none',
        },
        position: 'absolute',
        top: '11px',
        fontSize: '15px',
    },
    infoIcon: {
        color: theme.palette.white,
        background: theme.palette.cms?.primary || theme.palette.colorPrimary,
        cursor: 'pointer',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            position: 'static',
        },
    },
    closeIcon: {
        color: theme.palette.colorNeutral60,
        cursor: 'pointer',
        transform: 'scale(1.3)',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            position: 'static',
        },
    },
    clickToAdd: {
        fontSize: '11px',
        color: theme.palette.sympathyProductNameColor,
        textAlign: 'center',
        lineHeight: '1',
    },
    passportWrapper: {
        textAlign: 'center',
        lineHeight: '1',
    },
    celebrationText: {
        fontSize: '18px',
        color: theme.palette.cms?.passportBannerCelebrationTextColor,
        fontWeight: '500',
    },
    passportText: {
        fontSize: '24px',
        color: theme.palette.cms?.passportBannerPassportTextColor,
        fontWeight: 'bold',
        marginLeft: '13px',
        marginTop: '-4px',
    },
    celebrationTextInline: {
        fontSize: '18px',
        color: theme.palette.cms?.passportBannerCelebrationTextColor,
        fontWeight: 'bold',
    },
    passportTextInline: {
        fontSize: '18px',
        color: theme.palette.cms?.passportBannerPassportTextColor,
        fontWeight: 'bold',
        margin: '-2px 0 0 3px',
    },
    productPassportContainer: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'row nowrap',
        [theme.breakpoints.down(770)]: {
            flexFlow: 'column',
        },
    },
    productTwoLinePpContainer: {
        marginLeft: '10px',
        flexDirection: 'column',
        alignItems: 'start !important',
        '&>span': {
            margin: 0,
        },
    },
    twoLinePpIcon: {
        minWidth: '100px',
        width: '30% !important',
        '@media screen and (max-width: 768px)': {
            minWidth: '100px',
            width: '0% !important',
        },
    },
    twoLinePpFlexContainer: {
        alignItems: 'start !important',
        justifyContent: 'flex-start !important',
    },
    passportIcon: {
        width: '5em',
        verticalAlign: 'middle',
        float: 'left',
        display: 'block',
        marginRight: 10,
        [theme.breakpoints.down(1200)]: {
            margin: '0',
            width: '103px',
            height: '19px',
            marginBottom: '2px',
        },
        [theme.breakpoints.down(770)]: {
            alignSelf: 'flex-start',
        },
    },
    passportSupText: {
        fontSize: '14px',
        marginLeft: '2px',
    },
    learnMore: {
        fontSize: '14px',
        color: theme.palette.common?.black,
        fontWeight: 'bold',
        marginLeft: '-5px',
        marginTop: '5px',
        textDecoration: 'none',
    },
    learnMorePayment: {
        fontSize: '14px',
        color: theme.palette.common?.black,
        fontWeight: 'bold',
        marginTop: '3px',
        textDecoration: 'none',
        marginLeft: '19px',
        textAlign: 'left',
    },
    cardPassportPayment: {
        padding: '7px',
        marginRight: '7px',
        position: 'relative',
        borderRadius: '10px',
        border: `2px solid ${theme.palette.primary?.main}`,
        '&:after': {
            position: 'absolute',
            content: '""',
            border: `2px solid ${theme.palette.primary?.main}`,
            borderBottom: 'none',
            borderLeft: 'none',
            width: '25px',
            height: '25px',
            top: '31px',
            right: '-14px',
            transform: 'rotate(45deg)',
            '-webkit-transform': 'rotate(45deg)',
            display: 'block',
            background: theme.palette.white,
            zIndex: '13',
        },
        '&$promoApplied:after': {
            top: '57px',
        },
    },
    promoApplied: {
        position: 'relative',
    },
    [theme.breakpoints.only('xs')]: {
        cardPassportPayment: {
            margin: '0 auto',
            '&:after, &$promoApplied:after': {
                display: 'none',
            },
        },
    },
    [theme.breakpoints.down('md')]: {
        cardPassportPayment: {
            '&:after, &$promoApplied:after': {
                display: 'none',
            },
        },
    },
    passportDescFoodDynamicPayment: {
        fontSize: '13px',
        color: theme.palette.black,
        lineHeight: '17px',
        width: '140px',
        height: '70px',
        marginLeft: '19px',
        zIndex: '2',
        [theme.breakpoints.down('md')]: {
            width: 'calc(100% - 19px)',
            height: 'auto',
        },
    },
    ariaInvisible: {
        clip: 'rect(0 0 0 0)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        width: '1px',
    },
    setTextAlign: {
        [theme.breakpoints.down('md')]: {
            textAlign: 'center',
        },
    },
    signIn: {
        '& > p': {
            margin: 0,
        },
        '& #sign_in_link': {
            cursor: 'pointer',
        },
    },
    passportCardWrapper: {
        '& $passportDesc': {
            fontSize: '14px',
            lineHeight: '22px',
            marginTop: '4px',
            letterSpacing: '0.5px',
            [theme.breakpoints.down(1200)]: {
                marginLeft: '0px',
            },
        },
        '& $flexContainer': {
            alignItems: 'flex-start',
            justifyContent: 'unset',
            padding: '0px 16px',
        },
        '& $checkbox': {
            padding: '0px',
        },
        '& $checkboxContainer': {
            justifyContent: 'flex-end',
        },
        '& $textBlock': {
            paddingLeft: '12px',
            [theme.breakpoints.down(1200)]: {
                flexGrow: 0,
                maxWidth: '95%',
                flexBasis: '95%',
            },
        },
        '& $productPassportContainer': {
            alignItems: 'flex-start',
        },
        [theme.breakpoints.up('600')]: {
            padding: '0px',
            '& $textBlock': {
                paddingLeft: '10px',
            },
            '& $productPassportContainer': {
                flexDirection: 'column',
                padding: '2px 2px 0px',
                flexWrap: 'wrap',
            },
            '& $flexContainer': {
                padding: '0px 16px 0px 8px',
            },
            '& $passportDesc': {
                lineHeight: '24px',
            },
        },
    },
    passportLoyalty: {
        textDecoration: 'underline',
        textDecorationThickness: '1px',
        textUnderlineOffset: '3px',
        fontSize: '12px',
        lineHeight: '14.4px',
        alignSelf: 'flex-start',
        marginTop: '4px',
        letterSpacing: '0.5px',
        cursor: 'pointer',
        display: 'flex',
        [theme.breakpoints.up('600')]: {
            lineHeight: '20px',
        },
        '& svg': {
            marginLeft: '8px',
            [theme.breakpoints.down('600')]: {
                width: '20px',
                height: '20px',
            },
        },
    },
    passportBock: {
        display: 'flex',
        alignItems: 'center',
    },
    passportImage: {
        width: 'auto',
        height: '18px',
        marginRight: '8px',
    },
    passportContent: {
        fontSize: '18px',
        lineHeight: '20px',
        letterSpacing: '0.5px',
        fontFamily: 'Area Variable, LatoBold',
        fontWeight: 700,
        [theme.breakpoints.down('600')]: {
            fontSize: '16px',
        },
    },
    pdpShortStyle: {
        '& $textBlock': {
            '@media screen and (min-width: 600px) and (max-width:700px)': {
                maxWidth: '95%',
                flexBasis: '95%',
                marginLeft: '10px',
            },
        },
    },
});

class PassportCardWithCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // displayLearnMore: false,
            toggled: false,
            disableCheckBox: false,
        };
    }

    componentDidMount() {
        const {
            isPassportBundleProduct, trackPassport,
            bannerOnPage, passportData, featureFlags,
            callClearPassportErrors, passportABData,
        } = this.props;

        const label = getTrackingLabel(isPassportBundleProduct, passportData, featureFlags['is-passport-conditional-offer-on']);
        let pdpEventLabel = label;
        if (featureFlags['is-passport-pdp-ga-tagging-enabled']) {
            if (validatePassport('isNonPassportUser', passportData)) pdpEventLabel = 'enrollment module';
            else pdpEventLabel = 'existing member module';
        }

        if (passportABData?.passport_item_sku
            && passportABData?.bundle_details?.pdpage_message
            && passportABData?.a_b_testing?.tracking_event_action
            && passportABData?.a_b_testing?.tracking_event_category) {
            const { a_b_testing: { tracking_event_category, tracking_event_action } } = passportABData;
            if (bannerOnPage === 'product') {
                trackPassport({
                    eventCategory: 'pdp',
                    eventAction: 'Passport Banner Impression',
                    eventLabel: pdpEventLabel,
                    nonInteraction: true,
                });
            }
            if (bannerOnPage === 'payment') {
                trackPassport({
                    eventCategory: tracking_event_category,
                    eventAction: `${tracking_event_action} - ${bannerOnPage} page`,
                    eventLabel: label,
                    queued: true,
                });
            }
        } else {
            if (bannerOnPage === 'product') {
                trackPassport({
                    eventCategory: 'pdp',
                    eventAction: 'Passport Banner Impression',
                    eventLabel: pdpEventLabel,
                    nonInteraction: true,
                });
            }

            if (bannerOnPage === 'payment') {
                trackPassport({
                    eventCategory: 'Checkout',
                    eventAction: 'Passport Banner Impression - Payment page',
                    eventLabel: label,
                    queued: true,
                });
            }
            if (bannerOnPage === 'payment-floral') {
                trackPassport({
                    eventCategory: 'Checkout',
                    eventAction: 'PP Enrollment Placement Impression',
                    eventLabel: 'checkout payment',
                    nonInteraction: true,
                    queued: true,
                });
            }
        }

        // clear passport error
        callClearPassportErrors();
    }

    // toggleLearnMoreModal = () => {
    //     const { displayLearnMore }  = this.state;
    //     this.setState({
    //         displayLearnMore: !displayLearnMore,
    //     });
    // }

    handleClick = () => {
        const { toggled } = this.state;
        const {
            isPlaRedesignEnabled, bannerOnPage, trackPassport,
        } = this.props;

        this.setState({
            toggled: !toggled,
        });

        if (isPlaRedesignEnabled && bannerOnPage === 'product') {
            trackPassport({
                eventCategory: 'PLA What is Passport',
                eventAction: 'Click',
                eventName: 'feature_interaction',
                eventLabel: `${!toggled ? 'show' : 'hide'}`,
                feature_detail: `${!toggled ? 'show' : 'hide'}`,
                feature_element: 'Category Viewed',
                feature_category: 'PLA What is Passport',
            });
        }
    };

    handleSignIn = async () => {
        const { auth } = this.props;
        trackEvent({
            eventCategory: 'Sign In', eventAction: 'Login', eventLabel: 'Login_From_Passport_PDP',
        });

        await auth.loginByRedirect();
    }

    componentDidUpdate(prevProps) {
        const { passportOptIn, passportError, cartCount } = this.props;
        if (passportOptIn !== prevProps.passportOptIn
            || passportError !== prevProps.passportError
            || cartCount !== prevProps.cartCount
        ) {
            this.setState({
                disableCheckBox: false,
            });
        }
    }

    // Persist passport data (window.dataLayer)
    @track(trackPassportData)
    render() {
        const {
            classes, passportOptIn, isAuthenticated,
            pdpMessage, showPriceNonMembers, pdpSignInVariant,
            bannerOnPage, passportDynamicCharge, passportData,
            passportError, presentation_family, appliedPromos,
            passportPageUrl, featureFlags, trackPassport, setPassportCodeAction,
            isPassportBundleProduct, cartData, triggerSubscription,
            passportCampaignData, passportSignInData, passportABData, passportThresholdVariant, isPlaRedesignEnabled,
            passportInEligibleProductsInCart, activeABTests, cartCount, isPdpRedesignEnabled, isPdpRedesignShortEnabled,
        } = this.props;

        const { toggled, disableCheckBox } = this.state;
        const newSubscriptionsExp = featureFlags['is-subscription-exp-enabled'] && bannerOnPage === 'subscriptionsExp';
        const enableSignIn = !isAuthenticated && pdpSignInVariant === 'variant';
        const passportHeadingBlock = passportData?.default_passport_messages?.passport_heading_block || {};
        let negativePassportDynamicCharge = false;
        if (passportDynamicCharge.includes('-')) {
            negativePassportDynamicCharge = true;
        }

        let classPassportFood = classes.cardPassportPayment;
        if (appliedPromos?.appliedPromotions?.length > 0) {
            classPassportFood = `${classes.cardPassportPayment} ${classes.promoApplied}`;
        }

        const passportDetails = {};
        const isFoodBrand = presentation_family === 'food';
        let pdpReskinStyle = '';
        if (isPdpRedesignShortEnabled) {
            pdpReskinStyle = `${classes.passportCardWrapper} ${classes.pdpShortStyle}`;
        } else if (isPdpRedesignEnabled) {
            pdpReskinStyle = classes.passportCardWrapper;
        }
        // Passport Price
        let passportPrice = passportData?.price;
        // Passport Signin/SignOut Prices
        if (passportSignInData?.price) passportPrice = passportSignInData.price;

        // Passport Term
        const shortText = passportData?.duration_short_text || 'year';
        let longText = passportData?.duration_long_text || '1 year';
        // AB Passport SKU
        if (passportABData?.bundle_details?.term_for_enrolment_page) longText = passportABData.bundle_details.term_for_enrolment_page;
        // Passport Signin/SignOut SKU
        if (passportSignInData?.passportEnrolmentTerm) longText = passportSignInData.passportEnrolmentTerm;
        // Passport URL Campaign SKU
        if (passportCampaignData?.passportEnrolmentTerm) longText = passportCampaignData.passportEnrolmentTerm;

        // Passport SKU to be passed in
        passportDetails.itemSku = passportData?.item_id;
        // AB Passport
        if (passportABData?.passport_item_sku) passportDetails.itemSku = passportABData.passport_item_sku;
        // Passport Signin/SignOut SKU
        if (passportSignInData?.itemSku) passportDetails.itemSku = passportSignInData.itemSku;
        // Passport URL Campaign SKU
        if (passportCampaignData?.itemSku) passportDetails.itemSku = passportCampaignData.itemSku;

        // floral & food brands
        passportDetails.checkoutPageMessage = <><span className={`${classes.boldText}`}>Yes</span>, I want Free Shipping/No Service Charge for {longText} with Passport.</>;

        if (presentation_family !== 'food' || featureFlags['enable-same-pdp-pp-copy']) {
            passportDetails.pdPageMessage = <>FREE Shipping/No Service Charge on Eligible Items for {longText} for Only ${passportPrice}. Automatically Renews for $29.99/Year after your first year.</>;
            if (passportDynamicCharge !== 'NA' && !negativePassportDynamicCharge) {
                passportDetails.checkoutPageMessage = <>{longText} FREE shipping for <span className={`${classes.boldText}`}>${`${passportDynamicCharge}`}</span> more.</>;
            }

            if (passportInEligibleProductsInCart && featureFlags['is-passport-ineligible-message-enabled']) {
                passportDetails.checkoutPageMessage = <>{longText} FREE shipping for <span className={`${classes.boldText}`}>${`${passportDynamicCharge}`}</span> more on Eligible Items.</>;
            }
        } else {
            passportDetails.pdPageMessage = <><span className={`${classes.boldText}`}>Yes</span>, I want Free Shipping/No Service Charge for {longText} with Passport.</>;
            if (passportDynamicCharge !== '' && !negativePassportDynamicCharge) {
                passportDetails.checkoutPageMessage = <>For only <span className={`${classes.boldText}`}>${passportDynamicCharge}</span> more you can get free shipping for {longText}.</>;
            }
            if (passportInEligibleProductsInCart && featureFlags['is-passport-ineligible-message-enabled']) {
                passportDetails.checkoutPageMessage = <>For only <span className={`${classes.boldText}`}>${passportDynamicCharge}</span> more you can get free shipping for {longText} on eligible products.</>;
            }
        }

        // CMS logic on PDPage
        const { messaging_at_entrance } = passportData;
        if (messaging_at_entrance?.enable_non_member_message && messaging_at_entrance?.non_member_message !== null) {
            passportDetails.pdPageMessage = messaging_at_entrance.non_member_message;
        }

        // AB Passport
        if (passportABData?.bundle_details?.pdpage_message) passportDetails.pdPageMessage = passportABData.bundle_details.pdpage_message;
        // SignIn/SignedOut flow
        if (passportSignInData?.productPageMessage) passportDetails.pdPageMessage = passportSignInData.productPageMessage;
        // Passport URL Campaign Logic
        if (passportCampaignData?.productPageMessage) passportDetails.pdPageMessage = passportCampaignData.productPageMessage;

        // AB Passport
        if (passportABData?.bundle_details?.checkout_page_message
            && passportABData.bundle_details.checkout_page_message.length > 0) {
            passportDetails.checkoutPageMessage = passportABData.bundle_details.checkout_page_message;
        }
        // SignIn/SignedOut flow
        if (passportSignInData?.checkoutPageMessage
            && passportSignInData.checkoutPageMessage.length > 0) {
            passportDetails.checkoutPageMessage = passportSignInData.checkoutPageMessage;
        }
        // Passport URL Campaign Logic
        if (passportCampaignData?.checkoutPageMessage
            && passportCampaignData.checkoutPageMessage.length > 0) {
            passportDetails.checkoutPageMessage = passportCampaignData.checkoutPageMessage;
        }
        if (!passportCampaignData?.enable && featureFlags['passport-google-optimize']) {
            // Google Optimize AB Test
            if (
                (activeABTests.loaded || activeABTests.timeout)
                && passportData?.ab_testing?.variant?.passport_referenced_sku?.[0]?.price &&  passportData?.ab_testing?.control?.passport_referenced_sku?.[0]?.price
            ) {
                const passport = { ...passportData };
                if (activeABTests.passportSkuTest === 'Rule_One') {
                    const passportVariant = passportData.ab_testing.variant.passport_referenced_sku[0];
                    passportDetails.itemSku = passportVariant.item_sku;
                    passportDetails.price = passportVariant.price;
                    passportPrice = passportVariant.price;

                    if (passportVariant.price !== passport.price) {
                        passport.item_id = getSkuWithoutBrand(passportVariant.item_sku);
                        passport.price = passportVariant.price;
                        setPassportCodeAction(passport);
                    }
                } else {
                    const passportControl = passportData.ab_testing.control.passport_referenced_sku[0];
                    passportDetails.itemSku = passportControl.item_sku;
                    passportDetails.price = passportControl.price;
                    passportPrice = passportControl.price;

                    if (passportControl.price !== passport.price) {
                        passport.item_id = getSkuWithoutBrand(passportControl.item_sku);
                        passport.price = passportControl.price;
                        setPassportCodeAction(passport);
                    }
                }
            }
        }

        // hardcoded content
        const passportThresholdContent = 'Enjoy free shipping/no service charge on eligible orders of $25+ for a full year—only $19.99! Automatically renews at $29.99/year after your first year.';

        // CMS logic for PDP message
        const displayCMSText = !passportCampaignData?.productPageMessage && pdpMessage;
        let passportMessageText = pdpMessage;
        let cta_copy = `$${passportPrice}`;
        if (featureFlags['enable-passport-term']?.pdp) cta_copy = `${cta_copy}/${shortText}.`;
        const pp_copy = (message) => message?.replace('{passport_long_term}', longText)?.replace('{passport_price}', cta_copy) || '';
        // showPriceNonMembers flag is being used to get the celebrations_brand copy
        if (showPriceNonMembers) passportMessageText = `${passportMessageText} for ${longText} for Only ${cta_copy}`;
        else passportMessageText = <ReactMarkdown source={pp_copy(passportMessageText)} escapeHtml={false} />;

        // CMS logic at checkout
        const passportPricing = passportData?.passport_pricing_conditional_logic?.at_checkout || {};
        const cartDetails = cartData || {};
        if ((passportPricing?.enable)
            && (passportPricing?.number_of_items_in_cart >= cartCount)
            && (passportPricing?.shipping_value >= cartDetails?.totalShipping)
            && passportPricing?.message && passportPricing?.passport_referenced_sku?.[0]?.item_sku) {
            passportDetails.checkoutPageMessage = <>{passportPricing?.message}</>;
            passportDetails.checkoutItemSku = passportPricing.passport_referenced_sku[0].item_sku;
        }

        if (isPassportBundleProduct?.details?.bundle_details?.pdpage_message) {
            passportDetails.pdPageMessage = isPassportBundleProduct.details.bundle_details.pdpage_message;
        }
        if (passportDetails.pdPageMessage && typeof passportDetails.pdPageMessage === 'string') passportDetails.pdPageMessage = <ReactMarkdown source={pp_copy(passportDetails.pdPageMessage)} escapeHtml={false} />;

        const subscribePassport = () => {
            this.setState((prev) => ({
                disableCheckBox: !prev.disableCheckBox,
            }));
            const label = getTrackingLabel(isPassportBundleProduct, passportData, featureFlags['is-passport-conditional-offer-on']);
            let pdpEventLabel = label;
            if (featureFlags['is-passport-pdp-ga-tagging-enabled']) {
                if (validatePassport('isNonPassportUser', passportData)) pdpEventLabel = 'enrollment module';
                else pdpEventLabel = 'existing member module';
            }
            if (passportABData?.passport_item_sku
                && passportABData?.bundle_details?.pdpage_message
                && passportABData?.a_b_testing?.tracking_event_action
                && passportABData?.a_b_testing?.tracking_event_category) {
                const { a_b_testing: { tracking_event_category, tracking_event_action } } = passportABData;

                if (bannerOnPage === 'product') {
                    trackPassport({
                        eventCategory: 'pdp',
                        eventAction: `Passport Banner${passportOptIn ? ' Unsubscribe' : ''} Click`,
                        eventLabel: pdpEventLabel,
                    });
                }
                trackPassport({
                    eventCategory: tracking_event_category,
                    eventAction: `${tracking_event_action}${passportOptIn ? ' Unsubscribe' : ''} Click - ${bannerOnPage} page`,
                    eventLabel: label,
                });
            } else {
                if (bannerOnPage === 'product') {
                    trackPassport({
                        eventCategory: 'pdp',
                        eventAction: `Passport Banner${passportOptIn ? ' Unsubscribe' : ''} Click`,
                        eventLabel: pdpEventLabel,
                    });
                }

                if (bannerOnPage === 'payment') {
                    trackPassport({
                        eventCategory: 'Checkout',
                        eventAction: `Passport Banner${passportOptIn ? ' Unsubscribe' : ''} Click - Payment page`,
                        eventLabel: label,
                    });
                }
                if (bannerOnPage === 'payment-floral') {
                    trackPassport({
                        eventCategory: 'Checkout',
                        eventAction: `PP Enrollment Placement${passportOptIn ? ' Unsubscribe' : ''} Click`,
                        eventLabel: 'checkout payment',
                        queued: true,
                    });
                }
                if (bannerOnPage === 'subscriptionsExp') {
                    trackPassport({
                        eventCategory: 'Subscriptions Experience',
                        eventAction: `${passportOptIn ? 'Unsubscribe ' : ''}click – Step 4`,
                        eventLabel: 'Passport checkbox',
                    });
                }

                if (isPlaRedesignEnabled && bannerOnPage === 'product') {
                    trackPassport({
                        eventCategory: 'PLA Passport Checkbox',
                        eventAction: 'Click',
                        eventLabel: `${passportOptIn ? 'Unsubscribe' : 'subscribe'}`,
                        eventName: 'feature_interaction',
                        feature_detail: `${passportOptIn ? 'Unsubscribe' : 'subscribe'}`,
                        feature_element: 'Category Viewed',
                        feature_category: 'PLA Passport Checkbox',
                    });
                }
            }

            triggerSubscription(bannerOnPage, passportDetails?.itemSku);
        };

        let passportAddedPrice = `$${passportPrice}`;
        if (featureFlags['enable-passport-term']?.pdp) passportAddedPrice = `$${passportPrice}/${shortText}`;

        const enableCMSDefaultCopy = passportData?.default_passport_messages?.enable_default_copy;
        const passportAddedCopy = enableCMSDefaultCopy ? <ReactMarkdown source={pp_copy(passportData?.default_passport_messages?.passport_added_copy)} escapeHtml={false} /> : (
            <span>
                Celebrations Passport<sup>{ReactHtmlParser('&reg;')}</sup> has been added to your cart for {passportAddedPrice} for your first year. Automatically Renews at $29.99/year, Cancel Anytime.
            </span>
        );

        const oneLineBanner = () => (
            <>
                { (!isPassportBundleProduct?.details)
                    && (
                        <Grid xs={1} item>
                            <Grid className={classes.checkboxContainer} xs={12} item>
                                <InputLabel className={classes.ariaInvisible} htmlFor="passport-subscription">Passport</InputLabel>
                                <Checkbox
                                    id="chk-passport-subscription"
                                    data-test="pdp-check-passport-subscription"
                                    name="passportChecked"
                                    disabled={disableCheckBox}
                                    checked={passportOptIn}
                                    onChange={subscribePassport}
                                    icon={<CheckBoxOutlineBlankOutlined />}
                                    checkedIcon={<CheckBoxOutlined />}
                                    inputProps={{
                                        label: 'passport-subscription',
                                        id: 'passport-subscription',
                                    }}
                                    classes={{
                                        root: classes.checkbox,
                                        checked: classes.checked,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    )}
                <>
                    {
                        newSubscriptionsExp ? (
                            <Grid className={`${classes.alignLeft} ${classes.textBlock}`} md={11} xs={10} item>
                                <div className={`${classes.productPassportContainer} ${classes.productTwoLinePpContainer}`}>
                                    <div>
                                        <img className={`${classes.passportIcon} ${classes.twoLinePpIcon}`} src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt199dfd765a419907/61e09d4f14ef402247cebaac/PP_UpsellIcon.svg" alt="passport icon" />
                                    </div>
                                    {passportOptIn ? (
                                        <span className={classes.passportDesc} aria-hidden="true">
                                            {passportAddedCopy}
                                        </span>
                                    ) : (
                                        <span className={classes.passportDesc} aria-hidden="true">
                                            {displayCMSText ? passportMessageText : passportDetails?.pdPageMessage}
                                        </span>
                                    )}
                                </div>
                            </Grid>
                        ) : (
                            <Grid className={`${classes.alignLeft} ${classes.textBlock}`} md={11} xs={10} item>
                                {(bannerOnPage === 'product' || bannerOnPage === 'payment-floral')
                        && (
                            <div className={classes.productPassportContainer}>
                                {/* <span className={`${classes.boldText}`}>Yes</span>, I want Free Shipping/No Service Charge for {passportDurationTextLong} with Passport. */}
                                {isPdpRedesignEnabled && passportHeadingBlock?.heading
                                    ? (
                                        <div className={classes.passportBock}>
                                            {passportHeadingBlock?.icon?.url
                                                && (
                                                    <div className={classes.passportImage}>
                                                        <ResponsiveImage
                                                            path={passportHeadingBlock.icon.url}
                                                            alt="Passport Heading"
                                                            fullWidth
                                                        />
                                                    </div>
                                                )}
                                            <div className={classes.passportContent}>{passportHeadingBlock.heading || 'Passport Eligible'}</div>
                                        </div>
                                    )
                                    : (
                                        <div className={classes.passportBock}>
                                            {passportHeadingBlock?.icon?.url
                                                ? (
                                                    <div className={classes.passportImage}>
                                                        <ResponsiveImage
                                                            path={passportHeadingBlock.icon.url}
                                                            alt="Passport Heading"
                                                            fullWidth
                                                        />
                                                    </div>
                                                )
                                                : <img className={classes.passportIcon} src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt199dfd765a419907/61e09d4f14ef402247cebaac/PP_UpsellIcon.svg" alt="passport icon" />}
                                        </div>
                                    )}
                                <span className={`${classes.passportDesc} ${enableSignIn && classes.signIn}`} aria-hidden="true">
                                    {passportOptIn ? (
                                        <>
                                            { passportAddedCopy}
                                        </>
                                    ) : (
                                        <>
                                            { passportThresholdVariant ? passportThresholdContent
                                                : (
                                                    <>
                                                        { displayCMSText ? passportMessageText : passportDetails?.pdPageMessage }
                                                    </>
                                                )}
                                        </>
                                    )}
                                    {enableSignIn && <p aria-hidden="true" id="sign_in_link" onClick={this.handleSignIn}><u>Already a member? Sign In for your benefits to apply.</u></p>}
                                </span>
                                {isPdpRedesignEnabled && <div role="presentation" onClick={() => this.handleClick()} className={classes.passportLoyalty}>{passportData?.default_passport_messages?.pdp_dropdown_trigger_copy || 'What is Passport?'} {toggled ? <ChevronUp color="#2F363D" width={24} height={24} /> : <ChevronDown color="#2F363D" width={24} height={24} />}</div>}
                            </div>
                        )}
                                {(bannerOnPage === 'payment')
                        && (
                            <InputLabel htmlFor="chk-passport-subscription" className={classes.passportDesc} align="left">
                                {passportOptIn ? passportAddedCopy : passportDetails?.checkoutPageMessage}
                            </InputLabel>
                        )}
                            </Grid>
                        )
                    }
                    {!isPdpRedesignEnabled
                    && (
                        <Grid className={`${classes.alignLeft} ${classes.passportImg}`} md={1} xs={2} item>
                            <div className={classes.infoIconWrapper}>
                                <SvgIcon
                                    data-testid="infoCloseIcon" // unit test
                                    className={!toggled ? classes.infoIcon : classes.closeIcon}
                                    onClick={() => this.handleClick()}
                                >
                                    {toggled ? (
                                        <path d="M10.5,0.5c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S16,0.5,10.5,0.5L10.5,0.5zM15.5,14.1l-1.4,1.4l-3.6-3.6l-3.6,3.6l-1.4-1.4l3.6-3.6L5.5,6.9l1.4-1.4l3.6,3.6l3.6-3.6l1.4,1.4l-3.6,3.6L15.5,14.1L15.5,14.1z" />
                                    ) : (
                                        <path d="M12.4,14.9c0-0.2-0.3-0.4-0.5-0.4h-0.4v-6c0-0.2-0.2-0.4-0.4-0.4h-2c-0.2,0-0.4,0.2-0.4,0.4v0.7c0,0.2,0.2,0.4,0.4,0.4h0.4v4.9H9.1c-0.2,0-0.4,0.2-0.4,0.4v0.7c0,0.2,0.2,0.4,0.4,0.4H12c0.2,0,0.4-0.2,0.4-0.4V14.9L12.4,14.9zM11.7,5.5c0-0.2-0.3-0.4-0.5-0.4H9.8c-0.2,0-0.4,0.2-0.4,0.4v1.1C9.4,6.8,9.6,7,9.8,7h1.5c0.2,0,0.4-0.2,0.4-0.4V5.5L11.7,5.5z" />
                                    )}
                                </SvgIcon>
                            </div>
                            {/* <Typography align="left">
                        <a
                            href="/"
                            className={classes.linkStyle}
                            onClick={(event) => {
                                event.preventDefault();
                                // history.push('/passport-pwa');
                                this.toggleLearnMoreModal();
                            }}
                        >
                        Learn more.
                        </a>
                    </Typography> */}
                        </Grid>
                    )}
                </>
            </>
        );

        return (
            <div id="passport-card-with-checkout">
                <div className={`${classes.passPortCard} ${pdpReskinStyle}`}>
                    <Grid className={`${classes.flexContainer} ${newSubscriptionsExp && classes.twoLinePpFlexContainer}`} container spacing={0}>
                        {
                            (!isFoodBrand || (isFoodBrand && bannerOnPage === 'product')) ? (
                                oneLineBanner()
                            ) : (
                                <>
                                    {isFoodBrand && bannerOnPage === 'payment'
                                        && (
                                            <Grid container className={classPassportFood}>
                                                <Grid container>
                                                    <span className={classes.celebrationTextInline}>celebrations</span>
                                                    <span className={classes.passportTextInline}> passport<sup className={classes.passportSupText}>®</sup></span>
                                                </Grid>
                                                <Grid container>
                                                    <Grid xs={2} sm={3} md={3} lg={3} item align="left" className={classes.setTextAlign}>
                                                        <Grid xs={8} md={8} lg={8} item>
                                                            <InputLabel className={classes.ariaInvisible} htmlFor="passport-subscription">Passport</InputLabel>
                                                            <Checkbox
                                                                id="chk-passport-subscription"
                                                                data-test="pdp-check-passport-subscription"
                                                                name="passportChecked"
                                                                checked={passportOptIn}
                                                                disabled={disableCheckBox}
                                                                onChange={subscribePassport}
                                                                classes={{
                                                                    root: classes.checkbox,
                                                                    checked: classes.checked,
                                                                }}
                                                                icon={<CheckBoxOutlineBlankOutlined />}
                                                                checkedIcon={<CheckBoxOutlined />}
                                                                inputProps={{
                                                                    role: 'checkbox', // this is important for unit test.
                                                                    label: 'passport-subscription',
                                                                    id: 'passport-subscription',
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid xs={8} md={8} lg={8} item className={classes.clickToAdd}>
                                                            Click to add
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={10} sm={9} md={9} lg={9} className={classes.contInfo}>
                                                        <InputLabel htmlFor="chk-passport-subscription" className={classes.passportDescFoodDynamicPayment} align="left">
                                                            {passportOptIn ? passportAddedCopy : passportDetails?.checkoutPageMessage}
                                                        </InputLabel>
                                                        <Link id="learn-more-link" alt="Learn more" to={passportPageUrl} target="_blank" className={classes.learnMorePayment}>
                                                            Learn more &gt;
                                                        </Link>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                </>
                            )
                        }
                    </Grid>
                </div>
                <div>
                    {passportError && <ErrorMessage error={passportError} noShadow />}
                </div>
                {toggled && (
                    <Grid container spacing={0}>
                        <Grid xs={12} item>
                            <PassportBenefitsInfo passportData={passportData} isPdpRedesignEnabled={isPdpRedesignEnabled} passportThresholdVariant={passportThresholdVariant} isPlaRedesignEnabled={isPlaRedesignEnabled} />
                        </Grid>
                    </Grid>
                )}
            </div>
        );
    }
}

PassportCardWithCheckbox.propTypes = {
    activeABTests: object.isRequired,
    classes: object.isRequired,
    passportOptIn: bool.isRequired,
    triggerSubscription: func.isRequired,
    bannerOnPage: string.isRequired,
    passportDynamicCharge: string.isRequired,
    passportData: shape({
        item_id: string,
        duration_long_text: string,
        messaging_at_entrance: shape({
            enable_non_member_message: bool,
            non_member_message: string,
        }),
    }),
    isPdpRedesignEnabled: bool,
    passportError: string,
    presentation_family: string.isRequired,
    appliedPromos: shape({
        appliedPromotions: arrayOf(
            shape({
                code: string,
                shortDesc: string,
                exclusivityMsg: string,
            }),
        ),
    }).isRequired,
    passportPageUrl: string.isRequired,
    isPassportBundleProduct: shape({
        enable: bool,
        prices: {},
    }),
    cartCount: number,
    cartData: shape({
        totalShipping: number,
    }),
    featureFlags: object,
    trackPassport: func.isRequired,
    passportCampaignData: shape({
        checkoutPageMessage: string,
        productPageMessage: string,
    }),
    passportSignInData: shape({
        enable: bool,
        price: number,
        itemSku: string,
        passportEnrolmentTerm: string,
        checkoutPageMessage: string,
        productPageMessage: string,
    }),
    callClearPassportErrors: func.isRequired,
    passportABData: shape({
        passport_item_sku: string,
        bundle_details: shape({
            pdpage_message: string,
            checkout_page_message: string,
        }),
    }),
    passportInEligibleProductsInCart: bool,
    pdpMessage: string,
    showPriceNonMembers: bool.isRequired,
    setPassportCodeAction: func.isRequired,
    pdpSignInVariant: string,
    isAuthenticated: bool,
    auth: object.isRequired,
    isPdpRedesignShortEnabled: bool,
    passportThresholdVariant: bool,
    isPlaRedesignEnabled: bool,
};

PassportCardWithCheckbox.defaultProps = {
    passportData: {},
    passportError: '',
    isPassportBundleProduct: {},
    cartData: {},
    cartCount: 0,
    featureFlags: {},
    passportCampaignData: {},
    passportSignInData: {},
    passportABData: {},
    passportInEligibleProductsInCart: false,
    pdpMessage: null,
    pdpSignInVariant: 'control',
    isAuthenticated: false,
    isPdpRedesignEnabled: false,
    isPdpRedesignShortEnabled: false,
    passportThresholdVariant: false,
    isPlaRedesignEnabled: false,
};

const mapStateToProps = (state) => ({
    activeABTests: getActiveABTests(state),
    passportOptIn: getPassportSubscriptionStatus(state),
    featureFlags: getFeatureFlags(state),
    isPassportCapPriceReached: getIsPassportCapPriceReached(state),
    passportDynamicCharge: dynamicPassportCharge(state),
    passportData: getPassportData(state),
    passportError: getPassportError(state),
    appliedPromos: getAppliedPromotions(state),
    passportPageUrl: getPassportPageUrl(state),
    cartData: getCartOrder(state),
    cartCount: getCartCount(state),
    userProfile: getUserProfile(state),
    passportCampaignData: getPassportCampaignData(state),
    passportSignInData: getPassportSignInData(state),
    passportABData: getPassportABData(state),
    passportInEligibleProductsInCart: isPassportInEligibleProductsInCart(state),
    isAuthenticated: getIsAuthenticatedStatus(state),
    pdpSignInVariant: getActiveABTest('pdp_passport_banner_sign_in')(state),
});

const mapDispatchToProps = (dispatch) => ({
    triggerSubscription: bindActionCreators(triggerPassportSubscription, dispatch),
    callClearPassportErrors: bindActionCreators(clearPassportError, dispatch),
    trackPassport: bindActionCreators(trackEvent, dispatch),
    // getDynamicPassportCharge: bindActionCreators(getDynamicPassportCharge, dispatch),
    setPassportCodeAction: bindActionCreators(setPassportData, dispatch),
});

export default compose(
    withAuth,
    trackPage(),
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(PassportCardWithCheckbox);
